var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCompanyDocumentation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 60.7628H9C6.51465 60.7628 4.5 58.7482 4.5 56.2628V11.2628C4.5 8.77748 6.51465 6.76283 9 6.76283L25.1325 6.75C26.3318 6.7491 27.482 7.227 28.3275 8.0775L36 15.7628L63 15.75C65.4854 15.75 67.5 17.7647 67.5 20.25V29.2628H63V20.2628L34.1325 20.25L32.8275 18.9225L25.1325 11.25L9 11.2628V56.2628H27V60.7628ZM36 36.0128L31.4838 36L31.5 60.7628H36V36.0128ZM67.4896 40.4962L67.4809 62.469C67.4809 64.0076 66.2038 65.2628 64.6337 65.2628H43.3309C41.7609 65.2628 40.4838 64.0076 40.4838 62.467V34.2981C40.4838 32.7553 41.7609 31.5 43.3309 31.5L58.5 31.5128L67.5 40.5128L67.4896 40.4962ZM62.9773 60.7637L63 42.7628H56.25V36.0128H45V60.7628H63L62.9773 60.7637Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCompanyDocumentation);
export default __webpack_public_path__ + "static/media/ic-company-documentation.30092225799e26009732c8ce842755d8.svg";
export { ForwardRef as ReactComponent };